import { render } from "./AppMenu.vue?vue&type=template&id=d810fdb6&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=ts"
export * from "./AppMenu.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-d810fdb6"

export default script